import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import "./sidebar.css";
import DashboardIcon from "@material-ui/icons/Dashboard";
import CoPresentRoundedIcon from "@mui/icons-material/CoPresentRounded";
import LocalLibraryIcon from "@mui/icons-material/LocalLibrary";
import SchoolIcon from "@material-ui/icons/School";
import EventIcon from "@material-ui/icons/Event";
import InfoIcon from "@material-ui/icons/Info";
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import KeyboardArrowLeftIcon from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@material-ui/icons/KeyboardArrowRight";
import SettingsIcon from "@mui/icons-material/Settings";
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import AssignmentIcon from '@mui/icons-material/Assignment';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import FaceRetouchingNaturalIcon from '@mui/icons-material/FaceRetouchingNatural';
import Tooltip from "@mui/material/Tooltip";
import PeopleIcon from '@mui/icons-material/People';
import { routes } from "../../../helper/routes";
import config from "../../../helper/config";
import { customerConstants } from "../../../helper/constants";
import CampaignIcon from '@mui/icons-material/Campaign';
import { Payment, SubscriptionsSharp } from "@mui/icons-material";
import DataHandler from "../../../handlers/DataHandler";
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import { compoenentRenderFrom } from "../../../helper/namespace";
import ArticleIcon from '@mui/icons-material/Article';

const getCustomerFeatureFlag = () => {
  return config.customerConfigs.featureFlag;
};

const Sidebar = (props) => {
  const [isExpanded, setExpanded] = useState(false);
  const location = useLocation();

  const toggleSidebar = () => {
    setExpanded(!isExpanded);
  };

  const closeSidebar = () => {
    setExpanded(false);
  };

  const handleOutsideClick = (event) => {
    const sidebar = document.querySelector(".sidebar");
    if (sidebar && !sidebar.contains(event.target)) {
      closeSidebar();
    }
  };

  useEffect(() => {
    document.body.addEventListener("click", handleOutsideClick);

    return () => {
      document.body.removeEventListener("click", handleOutsideClick);
    };
  }, []);

  const renderMenuItem = (to, icon, label, additionalState = {}) => {
    const isActive = location.pathname === to;
    const iconElement = isExpanded ? icon : <Tooltip title={label} placement="right" arrow>{icon}</Tooltip>;

    return (
      <li key={to} className={isActive ? "active" : ""}>
        <Link to={{ pathname: to, state: { ...additionalState } }} >
          {isExpanded ? (
            <>
              {iconElement}
              <span>{label}</span>
            </>
          ) : (
            iconElement
          )}
        </Link>
      </li>
    );
  };

  const customer = getCustomerFeatureFlag();
  let customerPaperText, isCMC, isEdFoci, isCGC, isAEHS
  switch (customer) {
    case customerConstants.EXO_CUSTOMER1:
      customerPaperText = "Papers";
      isCMC = false
      isEdFoci = false
      isCGC = false
      isAEHS = false
      break;
    case customerConstants.EXO_CUSTOMER2:
      customerPaperText = "Past Papers";
      isCMC = true
      isEdFoci = false
      isCGC = false
      isAEHS = false
      break;
    case customerConstants.EDF_CUSTOMER3:
      customerPaperText = "Courses";
      isCMC = false
      isEdFoci = true
      isCGC = true
      isAEHS = false
      break;
    case customerConstants.EDF_CUSTOMER4:
      customerPaperText = "Courses";
      isCMC = false
      isEdFoci = true
      isCGC = false
      isAEHS = true
      break;
    case customerConstants.EDF_CUSTOMER5:
      customerPaperText = "Search";
      isCMC = false
      isEdFoci = true
      isCGC = false
      isAEHS = false
      break;
    default:
      customerPaperText = "Search";
      isCMC = false
      isEdFoci = true
      isCGC = false
      isAEHS = false
      break;
  }

  let isASAD = DataHandler.getFromSession('isASAD');

  return (
    <nav
      className={`sidebar ${isExpanded ? "expanded" : ""}`}
      onClick={(e) => e.stopPropagation()}
    >
      <div className="toggle-container">
        <button className="sidebar-toggle" onClick={toggleSidebar}>
          {isExpanded ? (
            <KeyboardArrowLeftIcon className="toggleArrow" />
          ) : (
            <KeyboardArrowRightIcon className="toggleArrow" />
          )}
        </button>
      </div>
      <ul className="list-unstyled components d-flex justify-content-center flex-column">
        {renderMenuItem(
          "/manage-dashboard",
          isEdFoci && isExpanded ? (
            <DashboardIcon style={{ marginRight: "8px" }} />
          ) : (
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
              <DashboardIcon />
              <span style={{ fontSize: "8px", marginTop: "4px" }}>Dashboard</span>
            </div>
          ),
          isExpanded ? "Dashboard" : ""
        )}

        {renderMenuItem(
          "/manage-search",
          isEdFoci && isExpanded ? (
            <ArticleIcon style={{ marginRight: "8px" }} />
          ) : (
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
              <ArticleIcon />
              <span style={{ fontSize: "8px", marginTop: "4px" }}>{customerPaperText}</span>
            </div>
          ),
          isExpanded ? customerPaperText : ""
        )}

        {!!props.isAdmin &&
          !isEdFoci &&
          renderMenuItem(
            "/manage-invitations",
            isEdFoci && isExpanded ? (
              <LocalLibraryIcon style={{ marginRight: "8px" }} />
            ) : (
              <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                <LocalLibraryIcon />
                <span style={{ fontSize: "8px", marginTop: "4px" }}>Requests</span>
              </div>
            ),
            isExpanded ? "Requests" : ""
          )}

        {!!props.isAdmin &&
          !isEdFoci &&
          renderMenuItem(
            "/manage-teacher",
            isEdFoci && isExpanded ? (
              <CoPresentRoundedIcon style={{ marginRight: "8px" }} />
            ) : (
              <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                <CoPresentRoundedIcon />
                <span style={{ fontSize: "8px", marginTop: "4px" }}>Teachers</span>
              </div>
            ),
            isExpanded ? "Teachers" : "",
            {
              privilege_edit: 1,
              privilege_add: 1,
              privilege_delete: 1,
              breadcrumb2: 'teachers',
              nodeTitle: '',
              mid: 100,
              main_table_id: 10,
              owner_restriction: null,
              lg_user_id: sessionStorage.getItem("table_log_id"),
              lg_user_table_id: sessionStorage.getItem("manage_user_id"),
              user_list_restriction: null
            }
          )}

        {!!props.isAdmin &&
          !isCMC &&
          !isEdFoci &&
          renderMenuItem(
            "/manage-parent",
            isEdFoci && isExpanded ? (
              <PeopleIcon style={{ marginRight: "8px" }} />
            ) : (
              <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                <PeopleIcon />
                <span style={{ fontSize: "8px", marginTop: "4px" }}>Parents</span>
              </div>
            ),
            isExpanded ? "Parents" : "",
            {
              privilege_edit: 1,
              privilege_add: 1,
              privilege_delete: 1,
              breadcrumb2: 'parents',
              nodeTitle: '',
              mid: 100,
              main_table_id: 3,
              owner_restriction: null,
              lg_user_id: sessionStorage.getItem("table_log_id"),
              lg_user_table_id: sessionStorage.getItem("manage_user_id"),
              user_list_restriction: null
            }
          )}

        {(!!props.isTeacher || !!props.isStudent) &&
          !isEdFoci &&
          renderMenuItem(
            "/announcements",
            isEdFoci && isExpanded ? (
              <CampaignIcon style={{ marginRight: "8px" }} />
            ) : (
              <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                <CampaignIcon />
                <span style={{ fontSize: "8px", marginTop: "4px" }}>Announcement</span>
              </div>
            ),
            isExpanded ? "Announcement" : "",
            {
              privilege_edit: props.isTeacher ? 1 : null,
              privilege_add: props.isTeacher ? 1 : null,
              privilege_delete: null,
              privilege_view: 1,
              breadcrumb2: 'announcement',
              nodeTitle: '',
              mid: 100,
              main_table_id: props.isTeacher ? 10 : 2,
              owner_restriction: null,
              lg_user_id: sessionStorage.getItem("table_log_id"),
              lg_user_table_id: sessionStorage.getItem("manage_user_id"),
              user_list_restriction: null,
              flg_list_active: null
            }
          )}

        {!!props.isStudent &&
          !isEdFoci &&
          renderMenuItem(
            "/subscriptions",
            isEdFoci && isExpanded ? (
              <Payment style={{ marginRight: "8px" }} />
            ) : (
              <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                <Payment />
                <span style={{ fontSize: "8px", marginTop: "4px" }}>Subscriptions</span>
              </div>
            ),
            isExpanded ? "Subscriptions" : "",
            {
              privilege_edit: 1,
              privilege_add: 1,
              privilege_delete: 1,
              nodeTitle: 'Subscriptions',
              privilege_view: 1,
              mid: 100,
              main_table_id: 10,
              owner_restriction: null,
              lg_user_id: sessionStorage.getItem("manage_user_id"),
              lg_user_table_id: sessionStorage.getItem("table_log_id"),
              user_list_restriction: null
            }
          )}

        {!!props.isParent &&
          !isEdFoci &&
          renderMenuItem(
            "/subscriptions",
            isEdFoci && isExpanded ? (
              <Payment style={{ marginRight: "8px" }} />
            ) : (
              <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                <Payment />
                <span style={{ fontSize: "8px", marginTop: "4px" }}>Subscriptions</span>
              </div>
            ),
            isExpanded ? "Subscriptions" : "",
            {
              privilege_edit: 1,
              privilege_add: 1,
              privilege_delete: 1,
              privilege_view: 1,
              nodeTitle: 'Subscriptions',
              mid: 100,
              main_table_id: 10,
              owner_restriction: null,
              lg_user_id: sessionStorage.getItem("manage_user_id"),
              lg_user_table_id: sessionStorage.getItem("table_log_id"),
              user_list_restriction: null,
              flg_list_active: 1,
              form_list_id: 29
            }
          )}

        {!!props.isParent &&
          renderMenuItem(
            "/register-student",
            isEdFoci && isExpanded ? (
              <CoPresentRoundedIcon style={{ marginRight: "8px" }} />
            ) : (
              <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                <CoPresentRoundedIcon />
                <span style={{ fontSize: "8px", marginTop: "4px" }}>Students</span>
              </div>
            ),
            isExpanded ? "Students" : "",
            {
              privilege_edit: 1,
              privilege_add: 1,
              privilege_delete: 1,
              breadcrumb2: 'Student Registration',
              nodeTitle: '',
              mid: 100,
              main_table_id: 10,
              owner_restriction: null,
              lg_user_id: sessionStorage.getItem("table_log_id"),
              lg_user_table_id: sessionStorage.getItem("manage_user_id"),
              user_list_restriction: null
            }
          )}

        {!!props.isStudent &&
          !isEdFoci &&
          renderMenuItem(
            "/my-requests",
            isEdFoci && isExpanded ? (
              <CoPresentRoundedIcon style={{ marginRight: "8px" }} />
            ) : (
              <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                <CoPresentRoundedIcon />
                <span style={{ fontSize: "8px", marginTop: "4px" }}>Parent Requests</span>
              </div>
            ),
            isExpanded ? "Parent Requests" : "",
            {
              privilege_edit: 1,
              privilege_add: 1,
              privilege_delete: 1,
              breadcrumb2: "Parent Requests",
              nodeTitle: '',
              privilege_view: 1,
              mid: 100,
              main_table_id: 10,
              owner_restriction: null,
              lg_user_id: sessionStorage.getItem("manage_user_id"),
              lg_user_table_id: sessionStorage.getItem("table_log_id"),
              user_list_restriction: null
            }
          )}

        {!!props.isAdmin &&
          renderMenuItem(
            "/manage-settings",
            isEdFoci && isExpanded ? (
              <SettingsIcon style={{ marginRight: "8px" }} />
            ) : (
              <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                <SettingsIcon />
                <span style={{ fontSize: "8px", marginTop: "4px" }}>Settings</span>
              </div>
            ),
            isExpanded ? "Settings" : ""
          )}

        {!!props.isAdmin && (isCGC || isAEHS) &&
          renderMenuItem(
            routes.manage_student,
            isEdFoci && isExpanded ? (
              <SupervisorAccountIcon style={{ marginRight: "8px" }} />
            ) : (
              <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                <SupervisorAccountIcon />
                <span style={{ fontSize: "8px", marginTop: "4px" }}>Students</span>
              </div>
            ),
            isExpanded ? "Students" : "",
            {
              form_list_id: isAEHS ? 38 : 32,
              privilege_edit: 1,
              privilege_add: 1,
              privilege_delete: 1,
              breadcrumb2: isAEHS ? 'AEHS Student Registration' : 'CGC Student Registration',
              nodeTitle: '',
              mid: 100,
              main_table_id: isAEHS ? 36 : 30,
              owner_restriction: null,
              lg_user_id: sessionStorage.getItem("manage_user_id"),
              lg_user_table_id: sessionStorage.getItem("table_log_id"),
              user_list_restriction: null,
              path: compoenentRenderFrom.SIDEBAR
            }
          )}

        {!!props.isTeacher &&
          isASAD &&
          renderMenuItem(
            routes.questions_library,
            isEdFoci && isExpanded ? (
              <HelpOutlineIcon style={{ marginRight: "8px" }} />
            ) : (
              <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                <HelpOutlineIcon />
                <span style={{ fontSize: "8px", marginTop: "4px" }}>Questions</span>
              </div>
            ),
            isExpanded ? "Questions" : ""
          )}

        {!!props.isTeacher &&
          isASAD &&
          renderMenuItem(
            routes.view_assessment,
            isEdFoci && isExpanded ? (
              <AssignmentIcon style={{ marginRight: "8px" }} />
            ) : (
              <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                <AssignmentIcon />
                <span style={{ fontSize: "8px", marginTop: "4px" }}>Papers</span>
              </div>
            ),
            isExpanded ? "Papers" : ""
          )}

        {!!props.isTeacher &&
          isASAD &&
          renderMenuItem(
            routes.settings_view,
            isEdFoci && isExpanded ? (
              <SettingsIcon style={{ marginRight: "8px" }} />
            ) : (
              <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                <SettingsIcon />
                <span style={{ fontSize: "8px", marginTop: "4px" }}>Settings</span>
              </div>
            ),
            isExpanded ? "Settings" : ""
          )}

        {renderMenuItem(
          "/manage-sitemap",
          isEdFoci && isExpanded ? (
            <AccountTreeIcon style={{ marginRight: "8px" }} />
          ) : (
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
              <AccountTreeIcon />
              <span style={{ fontSize: "8px", marginTop: "4px" }}>Site Map</span>
            </div>
          ),
          isExpanded ? "Site Map" : ""
        )}

        {/* {renderMenuItem(
          "/manage-crm",
          isEdFoci && isExpanded ? (
            <AccountTreeIcon style={{ marginRight: "8px" }} />
          ) : (
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
              <AccountTreeIcon />
              <span style={{ fontSize: "8px", marginTop: "4px" }}>CRM</span>
            </div>
          ),
          isExpanded ? "crm" : ""
        )} */}

        {renderMenuItem(
          "/main-calendar",
          isEdFoci && isExpanded ? (
            <CalendarMonthIcon style={{ marginRight: "8px" }} />
          ) : (
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
              <CalendarMonthIcon />
              <span style={{ fontSize: "8px", marginTop: "4px" }}>Calendar</span>
            </div>
          ),
          isExpanded ? "Calendar" : ""
        )}

        {/* <li>
          <Link to="/main-calendar">
            {isExpanded ? (
              <>
                <InfoIcon />
                <span>About</span>
              </>
            ) : (
              <InfoIcon />
            )}
          </Link>
        </li> */}

      </ul>
    </nav>

  );
};

export default Sidebar;
